var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCb006(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 40,
    viewBox: "0 0 76 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2564_49923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2183 0H7.98985C3.58376 0 0 3.58376 0 7.98985V32C0 36.4061 3.58376 39.9898 7.98985 39.9898H67.2081C71.6142 39.9898 75.198 36.4061 75.198 32V7.98985C75.198 3.58376 71.6142 0 67.2081 0H67.2183ZM74.1929 32.0102C74.1929 35.8579 71.066 38.9848 67.2183 38.9848H7.98985C4.14213 38.9848 1.01523 35.8579 1.01523 32.0102V7.98985C1.01523 4.14213 4.14213 1.01523 7.98985 1.01523H67.2081C71.0558 1.01523 74.1827 4.14213 74.1827 7.98985V32L74.1929 32.0102Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5336 33.797H7.67578V34.8122H67.5336V33.797Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60472 24.0812H7.67578V31.9797H9.60472V24.0812Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4973 27.1675H10.5684V31.9797H12.4973V27.1675Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4016 24.0812H13.4727V31.9797H15.4016V24.0812Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2942 20.8121H16.3652V31.9695H18.2942V20.8121Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1887 17.4518H19.2598V31.9797H21.1887V17.4518Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.091 19.3198H22.1621V31.9797H24.091V19.3198Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9856 15.2994H25.0566V31.9796H26.9856V15.2994Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8782 11.1371H27.9492V31.9696H29.8782V11.1371Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7707 9.65479H30.8418V31.9695H32.7707V9.65479Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.675 15.2994H33.7461V31.9796H35.675V15.2994Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5676 6.65991H36.6387V31.9797H38.5676V6.65991Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4621 9.65479H39.5332V31.9695H41.4621V9.65479Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3547 11.7462H42.4258V31.9696H44.3547V11.7462Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.259 15.2994H45.3301V31.9796H47.259V15.2994Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1516 20.528H48.2227V31.9696H50.1516V20.528Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0461 14.1726H51.1172V31.9696H53.0461V14.1726Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9387 17.4518H54.0098V31.9797H55.9387V17.4518Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.843 21.5533H56.9141V31.9696H58.843V21.5533Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7356 14.6091H59.8066V31.9797H61.7356V14.6091Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6301 15.7157H62.7012V31.9695H64.6301V15.7157Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5324 12.3553H65.6035V31.9696H67.5324V12.3553Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2564_49923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.2081,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb006);
export default __webpack_public_path__ + "static/media/cb_006.b57a80d1c69268ea50df262fd75aff61.svg";
export { ForwardRef as ReactComponent };